if (!customElements.get('product-description-accordions')) {
  customElements.define('product-description-accordions', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const original = this.querySelector('details');
      const content = original?.querySelector('.sbs-description-accordion__body');
      if (!content) return;
      this.dataset.ready = 'true';
      // Split only direct headings, leaving nested tables and other rich content intact.
      const children = Array.from(content.children);
      const tag = ['H2', 'H3'].find(name => children.some(child => child.tagName === name));
      if (!tag) return;
      const fragment = document.createDocumentFragment();
      let current;
      let count = 0;
      const addSection = heading => {
        const details = document.createElement('details');
        details.className = 'sbs-description-accordion';
        details.open = count++ === 0 && this.dataset.openFirst === 'true';
        const summary = document.createElement('summary');
        if (heading) summary.append(heading);
        else summary.textContent = original.querySelector('summary').textContent;
        const body = document.createElement('div');
        body.className = 'sbs-description-accordion__body rte';
        details.append(summary, body);
        fragment.append(details);
        return body;
      };
      for (const node of Array.from(content.childNodes)) {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === tag) {
          current = addSection(node);
        } else {
          if (!current && node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) continue;
          if (!current) current = addSection();
          current.append(node);
        }
      }
      this.replaceChildren(fragment);
    }
  });
}
